export default __webpack_public_path__ + "static/image1-ecd9ce0fb10ff2ff364776b1fb695ddf.jpeg";